/**
 * Rutas y lista de idiomas para i18next-http-backend (CRA: PUBLIC_URL).
 * Las carpetas bajo public/locales usan códigos cortos (en, es), no BCP-47 regional (en-US).
 *
 * CRA suele dejar PUBLIC_URL como URL absoluta si package.json tiene "homepage": "https://www…".
 * Usar esa URL en loadPath fuerza fetch a ese host; en subdominios (cliente.orgcloud.io) el GET
 * es cross-origin y suele fallar sin CORS → i18next no carga JSON y t('clave') muestra la clave.
 * Las rutas relativas (/locales/…) se resuelven siempre contra window.location.origin.
 */
export const I18N_SUPPORTED_LANGUAGE_CODES = ['es', 'en', 'fr', 'pt', 'it', 'de'] as const;

export function getI18nTranslationLoadPath(publicUrl: string = process.env.PUBLIC_URL || '', version = ''): string {
  const suffix = version ? `?v=${encodeURIComponent(version)}` : '';
  let base = String(publicUrl || '').trim().replace(/\/$/, '');
  if (/^https?:\/\//i.test(base)) {
    base = '';
  }
  if (!base) {
    return `/locales/{{lng}}/{{ns}}.json${suffix}`;
  }
  const prefix = base.startsWith('/') ? base : `/${base}`;
  return `${prefix}/locales/{{lng}}/{{ns}}.json`.replace(/\/+/g, '/') + suffix;
}
